export enum ICompetitionSalesPointRatingStatsWidgetFlow {
  place,
  purchases,
}

export interface ICompetitionSalesPointRatingStatsWidget {
  competitionId: number;
  participantId: number;
  flow?: ICompetitionSalesPointRatingStatsWidgetFlow;
  label: string;
}
